import { eIDsDoiTuongDuThiActionsObj } from "../../action-types/tct/IDsDoiTuongDuThiActions";
import { generateActionForKey, generateActions } from "../generateActions";
import { NotifyHelper } from "../../../helpers/toast";

export const dsDoiTuongDuThiActions = {
    ...generateActions(eIDsDoiTuongDuThiActionsObj, "DOI_TUONG_DU_THI"),
    ...generateActionForKey(eIDsDoiTuongDuThiActionsObj, "DOI_TUONG_DU_THI", "UPDATE_DUYET_SUCCESS", () => NotifyHelper.Success("Thành công")),
    ...generateActionForKey(eIDsDoiTuongDuThiActionsObj, "DOI_TUONG_DU_THI", "UPDATE_DUYET_ERROR", (m) => NotifyHelper.Error(m)),
}